module.exports = __webpack_public_path__ + "img/benefit-image05.c00ac2ed.png";